import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from 'src/app/interfaces';
import { IRelatorioFranquiaPorMaquinaBody } from 'src/app/interfaces/relatorio/FranquiaPorMaquina/IRelatorioFranquiaPorMaquinaBody';
import { IRelatorioFranquiaPorMaquinaResponseData } from 'src/app/interfaces/relatorio/FranquiaPorMaquina/IRelatorioFranquiaPorMaquinaResponseData';

@Injectable({
  providedIn: 'root'
})
export class RelatorioFranquiaPorMaquinaService {
  private readonly baseURL = '/RelatorioFranquiaPorMaquina';

  constructor(private httpClient: HttpClient) {}

  postRelatorioFranquiaPorMaquina(body: IRelatorioFranquiaPorMaquinaBody) {
    return this.httpClient.post<
      IApiResponse<IRelatorioFranquiaPorMaquinaResponseData>
    >(this.baseURL, body);
  }
}
